import { IEnrichedEvent } from '@bridebook/web/components/wedding-website/guest-rsvp/guest-rsvp.context';
import { formatEventTime } from '@bridebook/web/lib/events/event-date-formatters';
import { TFunction } from 'next-i18next';

const getEventDetailsCaption = (event: IEnrichedEvent, t: TFunction, locale: string) => {
  const { data, supplier } = event;

  // Show times in the market's clock convention, keep the raw value if it can't be parsed.
  const startTime =
    data?.time?.startTime && (formatEventTime(data.time.startTime, locale) || data.time.startTime);
  const endTime =
    data?.time?.endTime && (formatEventTime(data.time.endTime, locale) || data.time.endTime);

  const hasSupplier = Boolean(supplier);
  const hasStartTime = Boolean(startTime);
  const hasEndTime = Boolean(endTime) && hasStartTime;

  if (hasSupplier && hasEndTime) {
    return t('weddingWebsite:rsvp.events.eventDetailsCaption.allDetails', {
      startTime,
      endTime,
      supplierName: supplier?.name,
    });
  }

  if (hasStartTime && hasSupplier) {
    return t('weddingWebsite:rsvp.events.eventDetailsCaption.supplierAndStartTimeDetails', {
      startTime,
      supplierName: supplier?.name,
    });
  }

  if (hasEndTime) {
    return t('weddingWebsite:rsvp.events.eventDetailsCaption.timeOnlyDetails', {
      startTime,
      endTime,
    });
  }

  if (hasSupplier) {
    return t('weddingWebsite:rsvp.events.eventDetailsCaption.supplierOnlyDetails', {
      supplierName: supplier?.name,
    });
  }

  if (hasStartTime) return startTime;

  return '';
};

export default getEventDetailsCaption;
